import { styled } from '@mui/material/styles';
import AccordionDetails from '@mui/material/AccordionDetails';

export const AccordionItemBody = styled(AccordionDetails, { skipSx: false })(
  ({ theme }) => ({
    padding: theme.spacing(0),
    flexDirection: 'column',
  }),
);
